export const shouldShowAppDownloadBottomBanner = (
  showBanner: boolean,
  isMobileUserAgent: boolean
): boolean => {
  return showBanner && isMobileUserAgent
}
